var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYellowRedCard = function SvgYellowRedCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAD000",
    d: "M4 1h6.8a2 2 0 0 1 2 2v14.2H2V3a2 2 0 0 1 2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C00",
    d: "M9 3h6.8a2 2 0 0 1 2 2v14.2H7V5a2 2 0 0 1 2-2"
  }))));
};
export default SvgYellowRedCard;